import { render, staticRenderFns } from "./BaseModal.vue?vue&type=template&id=59f1c0aa&scoped=true&"
import script from "./BaseModal.vue?vue&type=script&lang=js&"
export * from "./BaseModal.vue?vue&type=script&lang=js&"
import style0 from "./BaseModal.vue?vue&type=style&index=0&id=59f1c0aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f1c0aa",
  null
  
)

export default component.exports